import { useSelector } from 'react-redux';
import { selectUserPermissions } from '../../features/login/login-selector';

const WithPermissions = ({
    render,
    permissions,
    featurePermissions,
    onPermissionDenied,
    shouldHide,
    allowFeaturePermission,
    eitherPermissionMatches,
    ...rest
}: any) => {
    let matcherFunction = 'every';
    const userPermissions = useSelector(selectUserPermissions);
    if (eitherPermissionMatches) {
        matcherFunction = 'some';
    }
    const isPermissionDenied = !permissions[matcherFunction](
        (permission: any) =>
            allowFeaturePermission && featurePermissions
                ? featurePermissions.includes(permission)
                : userPermissions.includes(permission)
    );

    let componentProps;
    if (isPermissionDenied) {
        if (shouldHide) {
            return null;
        }
        componentProps = onPermissionDenied(rest);
    }

    return render({
        ...rest,
        ...componentProps,
    });
};

export default WithPermissions;
